import store from 'state/store';
import {postMessage} from '../helper-functions/post-message';

export default class AdvanceCashierEvents {

    queue = [];
    unsubscribe = null;

    getEventIdentity = () => {
        const {profileInfo, initTheme} = store.getState();

        return {
            cid: (profileInfo?.customer?.pin || initTheme?.cid) ?? '',
            order_id: (profileInfo?.order_id || initTheme?.order_id) ?? ''
        };
    };

    handleAdvanceCashierEvent = ({detail}) => {
        const event = {...detail, ...this.getEventIdentity()};
        const {initTheme} = store.getState();

        if (initTheme?.currentDomain) {
            postMessage(event, initTheme.currentDomain);
            return;
        }

        this.queue.push(event);
    };

    sendQueuedEvents = () => {
        const {initTheme} = store.getState();

        if (initTheme?.currentDomain) {
            this.unsubscribe();
            this.queue.splice(0).forEach((event) => postMessage(event, initTheme.currentDomain));
            return;
        }

        if (initTheme?.validate_domain === false) {
            this.unsubscribe();
            this.queue.length = 0;
        }
    };

    constructor() {
        window.addEventListener('trigger_advance_cashier_event', this.handleAdvanceCashierEvent);
        this.unsubscribe = store.subscribe(this.sendQueuedEvents);
    }
}
